import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cta: 'Continue my registration',
    registration: 'Registration',
    reset: 'Reset my account',
    siret: 'SIRET',
    subtitle:
      'All information entered will be lost. You will be redirected to the selection of your situation',
    title: 'Reset my account for {companyName}',
  },
  fr: {
    cta: 'Continuer mon inscription',
    registration: 'Inscription',
    reset: 'Réinitialiser mon compte',
    siret: 'SIRET',
    subtitle:
      'Toutes les informations renseignées seront perdues. Vous serez redirigé vers l’étape de sélection de votre situation.',
    title: 'Réinitialiser mon compte pour {companyName}',
  },
} as const);
